import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./css/emi.css";
import constants from "../../../../Shared/constants/constants";
import swal from "sweetalert";
import BigNumber from "bignumber.js";
import emiAbi from "../../../../Shared/emiAbi.json";
import erc20Abi from "../../../../Shared/erc20Abi.json";
import Web3 from "web3";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const EMIoutstandingPay = () => {
    const [connectedWallet, setConnectedWallet] = useState(null);
    const [web3, setWeb3] = useState(null);
    const [isWalletConnected, setWalletConnected] = useState(false);
    const [collectionType, setCollectionType] = useState(constants.COLLECTION1);
    const [noOfTokens, setNoOfTokens] = useState(1);
    const [totalToPay, setTotalToPay] = useState(1);
    const [emiToPayNow, setEMIToPayNow] = useState(1);
    const [selectedCollectionCost, setSelectedCollectionCost] = useState(1);
    const [minimumToPay, setMinimumToPay] = useState(10);
    const [showCalculation, setShowCalculation] = useState(false);
    const [isAlreadyApproved, setIsAlreadyApproved] = useState(false);
    const [isApprovedTxAvailable, setIsApprovedTxAvailable] = useState(false);
    const [isPayTxAvailable, setIsPayTxAvailable] = useState(false);
    const [approvedTx, setApprovedTx] = useState(null);
    const [payTx, setPayTx] = useState(null);
    const [paymentToken, setPaymentToken] = useState(constants.PAY_TOKEN);

    const [TNCAgreed, setTNCAgreed] = useState(false);

    const getWalletConnectionStatus = () => {
        let _wallet = cookies.get("wallet");
        let _wallet_status = cookies.get("wallet_status");
        if (_wallet_status == true || _wallet_status == "true") {
            setWalletConnected(true);
            setConnectedWallet(_wallet);
            setWeb3(window.ethereum);
        } else {
            setWalletConnected(false);
            setConnectedWallet(null);
            setWeb3(null);
        }
    };

    const collectionOptions = [
        {
            label: constants.COLLECTION1_NAME,
            value: constants.COLLECTION1,
        },
        {
            label: constants.COLLECTION2_NAME,
            value: constants.COLLECTION2,
        },
        {
            label: constants.COLLECTION3_NAME,
            value: constants.COLLECTION3,
        },
    ];

    const chooseTokenOptions = [
        {
            label: "1",
            value: "1",
        },
        {
            label: "2",
            value: "2",
        },
        {
            label: "3",
            value: "3",
        },
        {
            label: "4",
            value: "4",
        },
        {
            label: "5",
            value: "5",
        },
        {
            label: "6",
            value: "6",
        },
        {
            label: "7",
            value: "7",
        },
        {
            label: "8",
            value: "8",
        },
        {
            label: "9",
            value: "9",
        },
        {
            label: "10",
            value: "10",
        },
    ];

    const choosePaymentTokenOptions = [
        {
            label: constants.PAY_TOKEN_NAME,
            value: constants.PAY_TOKEN,
        },
        {
            label: constants.PAY_TOKEN2_NAME,
            value: constants.PAY_TOKEN2,
        },
    ];

    const handleCollectionTypeChange = (type) => {
        setCollectionType(type.target.value);
        setShowCalculation(false);
    };

    const handleNoOfTokensChange = (noOfTokens) => {
        setNoOfTokens(parseInt(noOfTokens.target.value));
        setShowCalculation(false);
    };

    const handlePaymentTokensChange = (selectedPayToken) => {
        setPaymentToken(selectedPayToken.target.value);
        setShowCalculation(false);
    };

    const calculate = async () => {
        calculateEMIToPay(noOfTokens, collectionType);
        calculateTotalToPay(noOfTokens, collectionType);
        setShowCalculation(true);
        await isNFTContractApproved(paymentToken);
    };

    const calculateTotalToPay = async (count, type) => {
        let amountToPay = 0;
        amountToPay = await getCollectionFee(type);
        setTotalToPay(count * amountToPay);
    };

    const calculateEMIToPay = (count, type) => {
        setEMIToPayNow(count * minimumToPay);
    };

    const isNFTContractApproved = async (selectedPayToken) => {
        try {
            let web3 = new Web3(window.ethereum);
            console.log(
                `[nft][src][components][[pages]][EmiOutstandingPay] selectedToken`,
                selectedPayToken
            );
            if (
                selectedPayToken != "null" ||
                selectedPayToken != "0x0000000000000000000000000000000000000000"
            ) {
                let erc20 = await new web3.eth.Contract(
                    erc20Abi,
                    selectedPayToken
                );

                // balance to Pay
                let balanceToPay = new BigNumber(minimumToPay);

                let isApproved = await erc20.methods
                    .allowance(connectedWallet, constants.NITROMORTGAGE)
                    .call();

                let decimal = await erc20.methods.decimals().call();

                let baseBN = new BigNumber(10);
                let decimalBN = new BigNumber(decimal);

                let exponentiate = baseBN.exponentiatedBy(decimalBN);

                let isApprovedBN = new BigNumber(isApproved);
                let balanceToPayBN = new BigNumber(balanceToPay).multipliedBy(
                    exponentiate
                );

                let res = isApprovedBN.comparedTo(balanceToPayBN);
                console.log(
                    `[nft][src][components][[pages]][EmiOutstandingPay] res`,
                    res
                );

                if (res === 0 || res == 1) {
                    setIsAlreadyApproved(true);
                } else if (res == -1) {
                    setIsAlreadyApproved(false);
                }
                console.log(
                    `[nft][src][components][pages][EmiOutstandingPay][isNFTContractApproved] Is Approved`,
                    isAlreadyApproved
                );
            } else {
                setIsAlreadyApproved(false);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getCollectionFee = async (collectionContract) => {
        let web3 = new Web3(window.ethereum);
        if (web3 != null) {
            try {
                let EMI = await new web3.eth.Contract(
                    emiAbi,
                    constants.NITROMORTGAGE
                );
                let _fee = await EMI.methods.fees(collectionContract).call();
                let _minimum = await EMI.methods
                    .minimumInUSD(collectionContract)
                    .call();
                console.log("_minimum", _minimum);
                console.log("_fee", _fee);
                let _collectionFee = _fee / 1000000;
                setSelectedCollectionCost(_collectionFee);
                setMinimumToPay(_minimum);
                return _collectionFee;
            } catch (error) {
                console.log(error);
                setSelectedCollectionCost(0);
                return null;
            }
        }
    };

    const approveNFTContract = async () => {
        if (!TNCAgreed) {
            swal({
                text: "Please agree to terms and conditions",
                icon: "warning",
            });
            return;
        }

        let web3 = new Web3(window.ethereum);
        let accounts = await web3.eth.getAccounts();

        if (web3 != null) {
            try {
                console.log(
                    "[nft][src][components][pages][EmiOutstandingPay][approveNFTContract] Initiated"
                );
                console.log(
                    "[nft][src][components][pages][EmiOutstandingPay][approveNFTContract] Selected Token to Pay",
                    paymentToken
                );

                let payToken = paymentToken;
                let contractToApprove = constants.NITROMORTGAGE;
                let valueToApprove =
                    "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff";

                let ERC20 = await new web3.eth.Contract(erc20Abi, payToken);

                try {
                    await ERC20.methods
                        .approve(contractToApprove, valueToApprove)
                        .send({ from: accounts[0] })
                        .on("transactionHash", function (hash) {
                            setIsApprovedTxAvailable(true);
                            swal({
                                icon: "info",
                                title: "In progress",
                                text: "Transaction initiated, please wait for the transaction to complete!",
                                showConfirmButton: true,
                                showCancelButton: false,
                                allowOutsideClick: true,
                            });
                            console.log(
                                "[nft][src][components][pages][EmiOutstandingPay][approveNFTContract] Approve Tx Hash",
                                hash
                            );
                            let txHash = `${constants.AVAX_EXPLORER}/tx/${hash}`;
                            setApprovedTx(txHash);
                            waitTransactionReceipt(
                                hash,
                                "approve",
                                0,
                                function (err, receipt) {
                                    if (err != null) {
                                        return;
                                    }
                                }
                            );
                        })
                        .on("error", function (error, receipt) {
                            console.log(
                                "[nft][src][components][pages][EmiOutstandingPay][approveNFTContract] Approve Tx Error",
                                error
                            );
                            swal({
                                icon: "error",
                                title: "Failed",
                                text: "Transaction cancelled. Please try again!",
                                showConfirmButton: true,
                                showCancelButton: false,
                                allowOutsideClick: true,
                            });
                            setIsAlreadyApproved(false);
                            return;
                        });
                } catch (error) {
                    console.log(
                        "[nft][src][components][pages][EmiOutstandingPay][approveNFTContract] Catch Error",
                        error
                    );
                    swal({
                        icon: "error",
                        title: "Failed",
                        text: "Something went wrong. Please try again!",
                        showConfirmButton: true,
                        showCancelButton: false,
                        allowOutsideClick: true,
                    });
                    setIsAlreadyApproved(false);
                }
            } catch (error) {
                console.log(error);
            }
        }
    };

    const waitTransactionReceipt = async (
        transactionHash,
        actionType,
        timeOut,
        callback
    ) => {
        console.log(
            "[nft][src][components][pages][EmiOutstandingPay][waitTransactionReceipt] transactionHash",
            transactionHash
        );
        var web3 = new Web3(window.ethereum);

        let timeOutCounter = 0;
        let err = {
            message: "",
        };

        let isWaitRunning = false;

        let getReceiptTimerId = setInterval(function () {
            if (isWaitRunning == false) {
                isWaitRunning = true;
                web3.eth
                    .getTransaction(transactionHash)
                    .then(function (tx) {
                        if (tx == null) {
                            clearInterval(getReceiptTimerId);
                            console.log(
                                `[nft][src][components][pages][EmiOutstandingPay][waitTransactionReceipt] transactionHash ${transactionHash} is not found`
                            );
                            err.message = "Transaction hash is not found.";
                            isWaitRunning = false;
                            if (callback) {
                                callback(err, null);
                            }
                            return;
                        }

                        if (tx.blockNumber == null) {
                            if (timeOut > 0) {
                                timeOutCounter++;
                                if (timeOutCounter >= timeOut) {
                                    clearInterval(getReceiptTimerId);
                                    isWaitRunning = false;
                                    err.message =
                                        "Timeout while waiting transaction to confirm.";
                                    if (callback) {
                                        callback(err, null);
                                    }
                                    return;
                                } else {
                                    console.log(
                                        `[nft][src][components][pages][EmiOutstandingPay][waitTransactionReceipt] transactionHash 1 ${transactionHash} is pending`
                                    );
                                    isWaitRunning = false;
                                    return;
                                }
                            } else {
                                console.log(
                                    `[nft][src][components][pages][EmiOutstandingPay][waitTransactionReceipt] transactionHash 2 ${transactionHash} is pending`
                                );
                                isWaitRunning = false;
                                return;
                            }
                        }

                        // Transaction confirm
                        web3.eth
                            .getTransactionReceipt(transactionHash)
                            .then(async function (web3TxReceipt) {
                                clearInterval(getReceiptTimerId);
                                isWaitRunning = false;
                                if (web3TxReceipt == null) {
                                    console.log(
                                        `[nft][src][components][pages][EmiOutstandingPay][waitTransactionReceipt] transactionHash 2 ${transactionHash} is not found`
                                    );
                                    swal({
                                        icon: "error",
                                        title: "Failed",
                                        text: "Transaction Failed. Please try again!",
                                        showConfirmButton: true,
                                        showCancelButton: false,
                                        allowOutsideClick: true,
                                    });
                                    setIsAlreadyApproved(false);
                                }
                                console.log(
                                    `[nft][src][components][pages][EmiOutstandingPay][waitTransactionReceipt] Transaction receipt ${transactionHash}: ${web3TxReceipt}`
                                );

                                if (actionType == "approve") {
                                    swal({
                                        icon: "success",
                                        title: "Approved",
                                        text: "Transaction Successful",
                                        showConfirmButton: true,
                                        showCancelButton: false,
                                        allowOutsideClick: true,
                                    });
                                    setIsAlreadyApproved(true);
                                } else if (actionType == "emi") {
                                    swal({
                                        icon: "success",
                                        title: "EMI Success",
                                        text: "NFM purchased and staked successfully",
                                        showConfirmButton: true,
                                        showCancelButton: false,
                                        allowOutsideClick: true,
                                    });
                                    refreshPage();
                                }
                            })
                            .catch(function (error) {
                                clearInterval(getReceiptTimerId);
                                isWaitRunning = false;
                                console.log(
                                    `[nft][src][components][pages][EmiOutstandingPay][waitTransactionReceipt] Error on transaction receipt 1 ${transactionHash}: ${error}`
                                );
                                swal({
                                    icon: "error",
                                    title: "Cancelled",
                                    text: error.message,
                                    showConfirmButton: true,
                                    showCancelButton: false,
                                    allowOutsideClick: true,
                                });
                                setIsAlreadyApproved(false);
                            });
                    })
                    .catch(function (error) {
                        clearInterval(getReceiptTimerId);
                        console.log(
                            `[nft][src][components][pages][EmiOutstandingPay][waitTransactionReceipt] Error on transaction receipt 2 ${transactionHash}: ${error}`
                        );
                        swal({
                            icon: "error",
                            title: "Cancelled",
                            text: error.message,
                            showConfirmButton: true,
                            showCancelButton: false,
                            allowOutsideClick: true,
                        });
                        setIsAlreadyApproved(false);
                    });
            }
        }, 1000);
    };

    const payFirstEMI = async () => {
        console.log(
            `[nft][src][components][pages][modal][payFirstEMI] Initiated`
        );

        let payToken = paymentToken;

        console.log(
            `[nft][src][components][pages][modal][payFirstEMI] Selected Token`,
            payToken
        );

        let web3 = new Web3(window.ethereum);
        let accounts = await web3.eth.getAccounts();
        console.log(
            `[nft][src][components][pages][modal][payFirstEMI] accounts`,
            accounts
        );

        let ERC20 = await new web3.eth.Contract(erc20Abi, payToken);
        let userBalance = await ERC20.methods.balanceOf(connectedWallet).call();
        console.log(
            `[nft][src][components][pages][modal][payFirstEMI] userBalance`,
            userBalance
        );

        let userBalanceBN = new BigNumber(userBalance);
        // console.log(userBalanceBN, "userBalanceBN");

        let decimal = await ERC20.methods.decimals().call();
        // console.log("decimal", decimal);

        let decimalBN = new BigNumber(decimal);
        // console.log("decimalBN", decimalBN);

        let baseBN = new BigNumber(10);
        // console.log("baseBN", baseBN);

        let balanceToPay = new BigNumber(emiToPayNow);
        // console.log("balanceToPay", balanceToPay);

        let exponentiate = baseBN.exponentiatedBy(decimalBN);
        // console.log("exponentiate", exponentiate);

        let balanceToPayBN = new BigNumber(balanceToPay).multipliedBy(
            exponentiate
        );
        console.log(
            `[nft][src][components][pages][modal][payFirstEMI] Pay now`,
            balanceToPayBN.toString()
        );

        let res = userBalanceBN.comparedTo(balanceToPayBN);
        console.log(
            `[nft][src][components][pages][modal][payFirstEMI] Has enough balance`,
            res
        );

        // User have to pay Minimum Multiplied by No.of Tokens
        // have to pass this values independently
        let _minToPay = new BigNumber(minimumToPay);
        let _minToPay_exponentiate = baseBN.exponentiatedBy(decimalBN);
        let _minToPayBalanceToPayBN = new BigNumber(_minToPay).multipliedBy(
            _minToPay_exponentiate
        );
        let amountToPayNow = _minToPayBalanceToPayBN.toString();

        if (res === -1) {
            swal({
                icon: "error",
                title: "Failed",
                text: "Insufficient Funds. Please topup your Balance to proceed for payment",
                showConfirmButton: true,
                showCancelButton: false,
                allowOutsideClick: true,
            });
            return;
        }

        try {
            let EMI = await new web3.eth.Contract(
                emiAbi,
                constants.NITROMORTGAGE
            );

            console.log(collectionType, payToken, amountToPayNow, noOfTokens);

            await EMI.methods
                .buyAndStake(
                    collectionType,
                    payToken,
                    amountToPayNow,
                    noOfTokens
                )
                .send({ from: accounts[0] })
                .on("transactionHash", function (hash) {
                    console.log(
                        `[nft][src][components][components][modal][payNow] transactionHash`,
                        hash
                    );
                    swal({
                        icon: "info",
                        title: "In progress",
                        text: "Transaction initiated, please wait for the transaction to complete!",
                        showConfirmButton: true,
                        showCancelButton: false,
                        allowOutsideClick: true,
                    });
                    setIsPayTxAvailable(true);
                    let txHash = `${constants.EXPLORER_URL}/tx/${hash}`;
                    setPayTx(txHash);
                    waitTransactionReceipt(
                        hash,
                        "emi",
                        0,
                        function (err, receipt) {
                            if (err != null) {
                                return;
                            }
                        }
                    );
                })
                .on("error", function (error, receipt) {
                    console.log(
                        `[nft][src][components][components][modal][payNow] transactionHash error 1`,
                        error
                    );
                    swal({
                        icon: "error",
                        title: "Failed",
                        text: "Transaction cancelled. Please try again!",
                        showConfirmButton: true,
                        showCancelButton: false,
                        allowOutsideClick: true,
                    });
                    return;
                });
        } catch (error) {
            console.log(
                `[nft][src][components][components][modal][payNow] transactionHash error 2`,
                error
            );
            swal({
                icon: "error",
                title: "Failed",
                text: "Something went wrong. Please try again!",
                showConfirmButton: true,
                showCancelButton: false,
                allowOutsideClick: true,
            });
        }
    };

    const refreshPage = () => {
        window.location.reload();
    };

    useEffect(() => {
        getWalletConnectionStatus();

        // set default collection
        // setCollectionType(constants.COLLECTION1);

        console.log(
            `[nft][src][components][pages][EmiOutstandingPay][start] Wallet Status`,
            isWalletConnected
        );
        console.log(
            `[nft][src][components][pages][EmiOutstandingPay][start] Connected Wallet`,
            connectedWallet
        );
    });

    return (
        <div className="emi-screen ">
            {/*Outstanding Payment */}
            <div className="outstanding-payment">
                <h3 className="fw-600 text-center">Choose EMI</h3>

                <div className="field-outstanding">
                    <p className="mb-1">Choose NFM</p>
                    <select
                        name="collectionItem"
                        id="collectionItem"
                        onChange={(e) => handleCollectionTypeChange(e)}
                    >
                        {collectionOptions.map((option, i) => (
                            <option key={i} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="field-outstanding">
                    <p className="mb-1">No. of NFM</p>
                    <select
                        name="totalNFM"
                        id="totalNFM"
                        onChange={(e) => handleNoOfTokensChange(e)}
                    >
                        {chooseTokenOptions.map((option, i) => (
                            <option key={i} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="field-outstanding">
                    <p className="mb-1">Choose Crypto</p>
                    <select
                        name="totalNFM"
                        id="totalNFM"
                        onChange={(e) => handlePaymentTokensChange(e)}
                    >
                        {choosePaymentTokenOptions.map((option, i) => (
                            <option key={i} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </div>

                {showCalculation == true && (
                    <>
                        <div className="field-outstanding">
                            <p className="mb-1">Total Payable Amount</p>
                            <input
                                type="text"
                                placeholder="$1500"
                                value={noOfTokens * selectedCollectionCost}
                                // onChange={handleChange}
                                disabled
                            />
                        </div>

                        <div className="field-outstanding">
                            <p className="mb-1">Minimum Amount to be paid</p>
                            <input
                                type="text"
                                placeholder="$150"
                                value={noOfTokens * minimumToPay}
                                // value={payingAmount}
                                // onChange={handleChange}
                                disabled
                            />
                        </div>

                        <div className="d-flex align-items-center justify-content-center my-3">
                            <input
                                type="checkbox"
                                checked={TNCAgreed}
                                onChange={() =>
                                    setTNCAgreed((prevState) => !prevState)
                                }
                            />
                            <p className="mb-0 ml-2">
                                I agree to{" "}
                                <Link
                                    to="/terms-and-conditions"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="term-link"
                                >
                                    Terms & Conditions
                                </Link>
                            </p>
                        </div>
                    </>
                )}
                {/* NEW FIELD ADDED FROM HERE */}

                {/* 

                <div className="field-outstanding">
                    <p className="mb-1">Total Payable Amount</p>
                    <input
                        type="text"
                        placeholder="$1500"
                        // value={payingAmount}
                        // onChange={handleChange}
                        disabled
                    />
                </div>

                <div className="field-outstanding">
                    <p className="mb-1">Minimum Amount to be paid</p>
                    <input
                        type="text"
                        placeholder="$150"
                        // value={payingAmount}
                        // onChange={handleChange}
                        disabled
                    />
                </div>

                <div className="field-outstanding">
                    <p className="mb-1">Enter Amount</p>
                    <input
                        type="text"
                        placeholder="$300"
                        // value={payingAmount}
                        // onChange={handleChange}
                    />
                </div> */}

                {showCalculation == false && (
                    <div className="text-center">
                        <button
                            className="fw-600 gradient-butto-2 connect-wallet-btn"
                            onClick={calculate}
                        >
                            Calculate
                        </button>
                    </div>
                )}

                {/* {showCalculation == true && (
                    <div>
                        <p className="mb-0">
                            <small>Total Payable Amount:</small>{" "}
                        </p>
                        <p>
                            ${noOfTokens * selectedCollectionCost}{" "}
                            {`(${noOfTokens} X $${selectedCollectionCost})`}
                        </p>

                        <p className="mb-0">
                            <small>Minimum Amount to be paid:</small>{" "}
                        </p>
                        <p>
                            ${noOfTokens * minimumToPay}{" "}
                            {`(${noOfTokens} X $${minimumToPay})`}
                        </p>
                    </div>
                )} */}

                {showCalculation == true && isAlreadyApproved == true && (
                    <div className="text-center">
                        <button
                            className="fw-600 gradient-butto-2 connect-wallet-btn"
                            onClick={payFirstEMI}
                            disabled={!TNCAgreed}
                        >
                            Pay Now
                        </button>
                    </div>
                )}

                {showCalculation == true && isAlreadyApproved == false && (
                    <div className="text-center">
                        <button
                            className="fw-600 gradient-butto-2 connect-wallet-btn"
                            onClick={approveNFTContract}
                            disabled={!TNCAgreed}
                        >
                            Approve
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default EMIoutstandingPay;
